import React, { useEffect, useState } from "react";
import SlOption from "@shoelace-style/shoelace/dist/react/option";
import SlSelect from "@shoelace-style/shoelace/dist/react/select";
import "./Selector.css";

interface Props {
  options: { value: string; text: string }[];
  placeholder?: string;
  unselectedText?: string;
  onSelect: (value: string) => void;
  className?: string;
  label?: string;
  defaultValue?: string;
  value?: string;
}

function Selector({
  options,
  placeholder,
  onSelect,
  className,
  label,
  unselectedText,
  defaultValue,
  value,
}: Props) {
  const [currentValue, setCurrentValue] = useState(value || defaultValue || "");

  useEffect(() => {
    if (value !== undefined) {
      setCurrentValue(value);
    } else {
      setCurrentValue(defaultValue || "");
    }
  }, [value, defaultValue]);

  const handleValueChange = (text: string) => {
    setCurrentValue(text);
    // Buscar la opción correspondiente
    const selectedOption = options.find(option => option.value === text);
    
    if (selectedOption) {
      // Si encontramos la opción exacta, usar su valor original
      onSelect(selectedOption.value);
    } else {
      // Si no encontramos la opción exacta, puede ser que SlOption haya convertido espacios a "_"
      // Buscar por el valor con espacios convertidos a "_"
      const optionWithUnderscores = options.find(option => 
        option.value.replace(/\s+/g, '_') === text
      );
      
      if (optionWithUnderscores) {
        // Retornar el valor original de la opción
        onSelect(optionWithUnderscores.value);
      } else {
        // Si no encontramos nada, usar el valor tal como viene
        onSelect(text);
      }
    }
  };

  return (
    <div className={className}>
      <p className="text-sm font-semibold text-textPrimary">{label}</p>
      <SlSelect
        size="medium"
        placeholder={placeholder}
        onSlChange={(e: any) => handleValueChange(e?.target?.value)}
        value={currentValue}
        className="selector-input"
        hoist={true}
        style={{
          "--sl-z-index-dropdown": "99999",
          "--sl-panel-z-index": "99999"
        } as React.CSSProperties}
      >
        <SlOption value={""}>{unselectedText}</SlOption>
        {options.map(({ text, value }) => (
          <SlOption key={value} value={value}>
            {text}
          </SlOption>
        ))}
      </SlSelect>
    </div>
  );
}

export default Selector;
